import { MemberBasicsFragment } from '../graphql/types';

export const getMemberName = (
  member?:
    | Pick<MemberBasicsFragment, 'firstName' | 'lastName'>
    | null
    | undefined,
) => {
  const { firstName, lastName } = member || {};

  if (firstName && lastName) {
    return `${firstName} ${lastName}`;
  }

  if (firstName) {
    return firstName;
  }

  if (lastName) {
    return lastName;
  }

  return 'Unknown member';
};
